import {ethers} from "ethers";
import { ShareX_ABI } from "./abi/ShareX_ABI";
import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";

export class ShareXContract extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, ShareX_ABI.GetABI(), provider);
    }

    async deposite(value:string):Promise<any> {
        const wei = this._toWei(value);
        const res = await this._pay(wei, "deposite");
        return res;
    }

    async name(): Promise<string>
    {
        return this._call("name");
    }

    async symbol(): Promise<string>
    {
        return this._call("symbol");
    }   

    async totalSupply(): Promise<string>
    {
        const res = await this._call("totalSupply");
        return res;
    }   

    async approveWei(spenderAdr:string, amountWei:string):Promise<boolean>
    {
        const result = await this._send('approve', spenderAdr, amountWei); 
        return result;
    }

    async transfer(to:string, amountEth:string): Promise<any>
    {
        const result = await this._send('transfer', to, this._toWei(amountEth)); 
    }

    async transferWei(to:string, amountWei:string): Promise<any>
    {
        const result = await this._send('transfer', to, amountWei); 
    }

    async balanceOf(address:string)
    {
        const res = await this._call("balanceOf", address);
        return res;
    }


    async getBalance():Promise<string> {
        const res = await this._call("getBalance");
        return this._toDecimal(res);
    }
    async getBalanceToken(address:string):Promise<string> {
        const res = await this._call("getBalanceToken", address);
        return this._toDecimal(res);
    }


    async getConsumedBalance(address:string):Promise<string> {
        const res = await this._call("getConsumedBalance", address);
        return this._toDecimal(res);
    }
    async getConsumedBalanceETH():Promise<string> {
        const res = await this._call("getConsumedBalanceETH");
        return this._toDecimal(res);
    }


    async getCost(address:string) {
        const res = await this._call("getCost", address);
        return this._toDecimal(res);
    }
    async getCostETH() {
        const res = await this._call("getCostETH");
        return this._toDecimal(res);
    }


    async getShareCost(shareAddress:string, tokenAddress:string) {
        const res = await this._call("getShareCost", shareAddress, tokenAddress);
        return this._toDecimal(res);
    }
    async getShareCostETH(shareAddress:string) {
        const res = await this._call("getShareCostETH", shareAddress);
        return this._toDecimal(res);
    }


    async consumeIncomeETH():Promise<any> { return await this._send("consumeIncomeETH"); }
    async consumeIncomeERC20(address:string):Promise<any> { return await this._send("consumeIncomeERC20", address); }

    
    async withdrawETH():Promise<any> { return await this._send("withdrawETH"); }
    async withdrawERC20(address:string):Promise<any> { return await this._send("withdrawERC20", address); }
    
}